export default function hasNoData(noDataValue, pixel) {
  return pixel.includes(noDataValue);
}